export const CONSTANT_CLIENT_PROGRESS_STATUS = {
  RUNNING: ["RUNNING"],
  PENDING: ["PENDING", "ERROR"],
  SUCCESS: ["SUCCESS"],
  FAILED: ["FAILED"],
  UNLOCKED: ["UNLOCKED"],
};
